import map from 'lodash/map'

const requiredFields = {
  oldPassword: {
    rules: '',
    title: 'Old Password',
  },
  newPassword: {
    rules: '',
    title: 'New Password',
    min: 8,
  },
  newPasswordConfirmation: {
    rules: '',
    title: 'Re-type New Password',
    min: 8,
  },
}

const validator = value => {
  const errors = {}

  map(requiredFields, ({ max, title }, field) => {
    if (!value[field]) {
      errors[field] = `${title} field is required`
    } else if (value[field].length > max) {
      errors[field] = `Field reached ${max} characters`
    } else if (
      field === 'email' &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value[field])
    ) {
      errors[field] = `Invalid email format`
    } else if (
      field === 'newPassword' && !/[\w./<>?;:"'`!@#$%^&*`,()\[\]{}_+=|\\-]{6,}/.test(value[field]) // @TODO: t3st汉字 will go in
    ) {
      errors[
        field
      ] = `Password must be atleast 6 characters and only accept Alhanumerical and Symbols as input(not allowed: i.e, chinese characters).`
    } else if (field === 'newPasswordConfirmation' && value.newPassword !== value.newPasswordConfirmation) {
      errors[field] = `Your password do not match`
    }
  })

  return errors
}

export default validator
